import { createAction, props } from '@ngrx/store';

export const navClicked = createAction(
  '[Navigation] nav clicked',
  props<{ pageName: string }>()
);
